import { render, staticRenderFns } from "./desk-order.vue?vue&type=template&id=fa3089dc&scoped=true&"
import script from "./desk-order.vue?vue&type=script&lang=js&"
export * from "./desk-order.vue?vue&type=script&lang=js&"
import style0 from "./desk-order.vue?vue&type=style&index=0&id=fa3089dc&lang=scss&scoped=true&"
import style1 from "./desk-order.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3089dc",
  null
  
)

export default component.exports